import * as React from 'react';
import { PortCollection } from 'types/Port';
import { PortPill } from './PortPill';

interface Props {
  portCollections: PortCollection[];
  onRemovePort: (port: PortCollection) => void;
}

/**
 * Renders a list of ports as a cloud of pills
 */
export const PortCloud: React.FC<Props> = (props) => {
  const { portCollections, onRemovePort } = props;

  const pills = portCollections.map((portCollection) => (
    <PortPill key={portCollection.code} portCollection={portCollection} onRemove={onRemovePort} />
  ));

  return <div className="gap-x-4 gap-y-6 flex flex-wrap justify-center items-center">{pills}</div>;
};
PortCloud.displayName = 'CreateCompany.CompanyDetails.PortCloud';
